import { useState,useEffect } from "react";
import { apiRequest } from "../../network/apiClient";
import { API_ENDPOINTS } from "../../api/apiEndpoints";
import { toast } from "react-toastify";

const ContactsShowDetail = ({ selectedContactModal, contactData, setSelectedContactModal, onContactUpdated }) => {
    const [isEditing, setIsEditing] = useState(false);
    const [showLanguageDropdown, setShowLanguageDropdown] = useState(false);
    const parseRaceData = (raceString) => {
        if (!raceString) return { race: "Malay", raceOthers: "" };

        const predefinedRaces = ["Malay", "Chinese", "Indian"];

        if (predefinedRaces.includes(raceString)){
            return {race: raceString, raceOthers: ""};
        } else if ( raceString.includes(' - ')) {
            const [mainRace, otherRace] = raceString.split(' - ');
            return {race: "Others", raceOthers: otherRace || ""};
        }else {
            return {race: raceString, raceOthers: ""};
        }
    };
    const [newContact, setNewContact] = useState({
        salutation: "",
        name: "",
        designation: "",
        email: "",
        mobile_no: "",
        office_no: "",
        reporting_to: "",
        race_of_pic:"Malay",
        race_of_pic_others: "",
        language: ["English"],
    });

    useEffect(() => {
        if (contactData){
            const {race: initialRace, raceOthers: initialRaceOthers} = parseRaceData(contactData?.race_of_pic);
            setNewContact({
                salutation: contactData?.salutation || "MR.",
                name: contactData?.name || "",
                designation: contactData?.designation || "",
                email: contactData?.email || "",
                mobile_no: contactData?.mobile_no || "",
                office_no: contactData?.office_no || "",
                reporting_to: contactData?.reporting_to || "No One",
                race_of_pic: initialRace,
                race_of_pic_others: initialRaceOthers,
                language: contactData?.language ? contactData.language.split(", ").map(lang => lang.trim()) : ["English"],
            });
        }
    }, [contactData]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        if (name === "language") {
            // handle multiple select for language
            const selectedOptions = Array.from(e.target.selectedOptions, option => option.value);
            setNewContact(prevState => ({
                ...prevState,
                [name]: selectedOptions
            }));
        }else {
            setNewContact( prevState =>({
                ...prevState,
                [name]: value
            }));
        }
    };
    const handleSubmit = async (e) =>{
        e.preventDefault();

        try{
            newContact.contact_id = contactData.contact_id;
            const response = await apiRequest(`${import.meta.env.VITE_BASE_URL}/${API_ENDPOINTS.UPDATE_ACCOUNTS.UPDATE_CONTACTS}`, 'POST', newContact);

            if (response) {
                if (onContactUpdated) {
                    onContactUpdated();
                }
                toast.success('Contact Successfully Updated')
            } else{
                toast.error("Error updating contact");
            }
        }catch (error) {
            toast.error(error || "Error updating contact");
        }finally{
            const {race: resetRace, raceOthers: resetRaceOthers} = parseRaceData(contactData?.race_of_pic);
            setNewContact({
                salutation: contactData?.salutation || "MR.",
                name: contactData?.name || "",
                designation: contactData?.designation || "",
                email: contactData?.email || "",
                mobile_no: contactData?.mobile_no || "",
                office_no: contactData?.office_no || "",
                reporting_to: contactData?.reporting_to || "No One",
                race_of_pic: resetRace,
                race_of_pic_others: resetRaceOthers,
                language: contactData?.language ? contactData.language.split(", ").map(lang => lang.trim()) : ["English"],
            });
            setIsEditing(false);
            setSelectedContactModal(false);
        }
    }

    if (!selectedContactModal) return null;
    return(
        <div className="fixed inset-0 flex items-center justify-center z-50">
            <div
            className="fixed inset-0 bg-black opacity-50"
            onClick={() => {
                setSelectedContactModal(false)
                setIsEditing(false)}}></div>
            <div className="w-[65%] bg-white rounded-lg shadow-lg p-6 z-10">
                <div className="w-full flex justify-center items-center mb-4 border-b">
                    <h2 className="text-xl font-bold mb-4">View Contact</h2>
                </div>
                <div className="grid grid-cols-2 gap-x-5 ml-3 text-[#475569]">
                    <div className ="flex items-start mt-5">
                        <div className="border-b border-gray-200 pb-2 w-full flex">
                            <span className="w-1/2">Salutation</span>
                            {isEditing ? (
                                <select 
                                    className="w-full bg-transparent focus:outline-none" 
                                    defaultValue="MR."
                                    id = "salutation"
                                    name="salutation"
                                    value={newContact.salutation}
                                    onChange={handleInputChange}
                                    required
                                    >
                                        <option value="MR.">MR.</option>
                                        <option value="MS.">MS.</option>
                                        <option value="MRS.">MRS.</option>
                                </select>
                            ) : (
                                <span className="w-full">{contactData.salutation}</span>
                            )}
                        </div>
                    </div>
                    <div className ="flex items-start mt-5">
                        <div className="border-b border-gray-200 pb-2 w-full flex">
                            <span className="w-1/2" >Name</span>
                            {isEditing ? (
                                <input
                                    type="text"
                                    className="w-full"
                                    id = "name"
                                    name="name"
                                    placeholder={contactData.name}
                                    value={newContact.name}
                                    onChange={handleInputChange}
                                    required />
                            ) : (
                                <span className="w-full">{contactData.name}</span>
                            )}
                        </div>
                    </div>
                    <div className ="flex items-start mt-5">
                        <div className="border-b border-gray-200 pb-2 w-full flex">
                            <span className="w-1/2">Designation</span>
                            {isEditing ? (
                                <input
                                    type="text"
                                    className="w-full"
                                    id = "designation"
                                    name="designation"
                                    placeholder={contactData.designation}
                                    value={newContact.designation}
                                    onChange={handleInputChange}
                                    required />
                            ) : (
                                <span className="w-full">{contactData.designation}</span>
                            )}
                        </div>
                    </div>
                    <div className ="flex items-start mt-5">
                        <div className="border-b border-gray-200 pb-2 w-full flex">
                            <span className="w-1/2">Email</span>
                            {isEditing ? (
                                <input
                                    type="email"
                                    className="w-full"
                                    id = "email"
                                    name="email"
                                    placeholder={contactData.email}
                                    value={newContact.email}
                                    onChange={handleInputChange}
                                    required />
                            ) : (
                                <span className="w-full">{contactData.email}</span>
                            )}
                        </div>
                    </div>
                    <div className ="flex items-start mt-5">
                        <div className="border-b border-gray-200 pb-2 w-full flex">
                            <span className="w-1/2 whitespace-nowrap" >Mobile Number</span>
                            {isEditing ? (
                                <input
                                    type="text"
                                    className="w-full"
                                    id = "mobile_no"
                                    name="mobile_no"
                                    placeholder={contactData.mobile_no}
                                    value={newContact.mobile_no}
                                    onChange={handleInputChange}
                                    required />
                            ) : (
                                <span className="w-full">{contactData.mobile_no}</span>
                            )}
                        </div>
                    </div>
                    <div className ="flex items-start mt-5">
                        <div className="border-b border-gray-200 pb-2 w-full flex">
                            <span className="w-1/2 whitespace-nowrap" >Office Number</span>
                            {isEditing ? (
                                <input
                                    type="text"
                                    className="w-full"
                                    id = "office_no"
                                    name="office_no"
                                    placeholder={contactData.office_no}
                                    value={newContact.office_no}
                                    onChange={handleInputChange}
                                    required />
                            ) : (
                                <span className="w-full">{contactData.office_no || '-'}</span>
                            )}
                        </div>
                    </div>
                    <div className ="flex items-start mt-5">
                        <div className="border-b border-gray-200 pb-2 w-full flex">
                            <span className="w-1/2" >Reporting to</span>
                            {isEditing ? (
                                <select 
                                    className="w-full" 
                                    defaultValue={contactData.reporting_to}
                                    id = "reporting_to"
                                    name="reporting_to"
                                    value={newContact.reporting_to}
                                    onChange={handleInputChange}
                                    required
                                    >
                                        <option value="No One">No One</option>
                                        <option value="Owner / CEO / Director">Owner / CEO / Director</option>
                                        <option value="CFO / Finance Director / Finance Manager">CFO / Finance Director / Finance Manager</option>
                                        <option value="Partner">Partner</option>
                                </select>
                            ): (
                                <span className="w-full">{contactData.reporting_to}</span>
                            )}
                            
                        </div>
                    </div>
                    <div className ="flex items-start mt-5">
                        <div className="border-b border-gray-200 pb-2 w-full flex">
                            <span className="w-1/2" >Preferred Language</span>
                            {isEditing ? (
                                <div className="w-full relative">
                                    <div 
                                        className="w-full rounded px-2 py-1 cursor-pointer bg-white flex justify-between items-center"
                                        onClick={() => setShowLanguageDropdown(!showLanguageDropdown)}
                                        >
                                            <span>
                                                {newContact.language && newContact.language.length > 0
                                                    ? newContact.language.join(", ")
                                                    : "Select Language"}
                                            </span>
                                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="size-6">
                                                <path strokeLinecap="round" strokeLinejoin="round" d="m19.5 8.25-7.5 7.5-7.5-7.5" />
                                            </svg>
                                    </div>
                                    {showLanguageDropdown && (
                                        <div className="absolute top-full left-0 w-full bg-white border border-gray-200 rounded mt-1 z-10 shadow-lg">
                                            {['English', 'Bahasa Malaysia', 'Mandarin', 'Tamil', 'Hokkien', 'Cantonese'].map((lang) => (
                                                <label key={lang} className="flex items-center px-3 py-2 hover:bg-gray-100 cursor-pointer">
                                                    <input
                                                        type="checkbox"
                                                        value={lang}
                                                        checked={newContact.language.includes(lang)}
                                                        onChange={(e) => {
                                                            const {value, checked} = e.target;
                                                            setNewContact(prevState => ({
                                                                ...prevState,
                                                                language: checked
                                                                ? [...(prevState.language||[]), value]
                                                                : (prevState.language || []).filter(langItem => langItem !== value)
                                                            }));
                                                        }}
                                                        className="mr-2"
                                                    />
                                                    {lang}
                                                </label>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            ):(
                                <span className="w-full">{contactData.language}</span>
                            )}
                        </div>
                    </div>
                    <div className ="flex items-start mt-5">
                        <div className="border-b border-gray-200 pb-2 w-full flex">
                            <span className="w-1/2" >Race</span>
                            {isEditing ? (
                                <select 
                                    className="w-full" 
                                    id = "race_of_pic"
                                    name="race_of_pic"
                                    value={newContact.race_of_pic}
                                    onChange={handleInputChange}
                                    required
                                    >
                                        <option value="Malay">Malay</option>
                                        <option value="Chinese">Chinese</option>
                                        <option value="Indian">Indian</option>
                                        <option value="Others">Others</option>
                                </select>
                            ): (
                                <span className="w-full">
                                    {contactData?.race_of_pic?.includes(' - ')
                                    ? 'Others' 
                                    : contactData?.race_of_pic || '-'}
                                </span>
                            )}
                        </div>
                    </div>
                    {(isEditing && newContact.race_of_pic ==='Others') && (
                        <div className ="flex items-start mt-5">
                            <div className="border-b border-gray-200 pb-2 w-full flex">
                                <span className="w-1/2 whitespace-nowrap" >If Others, Specify</span>
                                <input 
                                    type="text" 
                                    className="w-full"
                                    id = "race_of_pic_others"
                                    name="race_of_pic_others"
                                    value={newContact.race_of_pic_others}
                                    placeholder="Please specify"
                                    onChange={handleInputChange}
                                    required />
                            </div>
                        </div>
                    )}
                    {(!isEditing && contactData?.race_of_pic?.includes(' - ')) && (
                        <div className="flex items-start mt-5">
                            <div className="border-b border-gray-200 pb-2 w-full flex">
                                <span className="w-1/2 whitespace-nowrap" >If Others, Specify</span>
                                <span className="w-full">{contactData.race_of_pic.split(' - ')[1] || '-'}</span>
                            </div>
                        </div>
                    )}
                </div>
                <div className="flex justify-end mt-6 gap-4">
                    {isEditing ? (
                        <>
                        <button
                            onClick={handleSubmit}
                            className="mt-4 bg-blue-500 text-white px-4 py-2 rounded"
                        >
                            Save
                        </button>
                        <button
                            onClick={() => setIsEditing(false)}
                            type="button"
                            style={{ backgroundColor: "#F9FAFB" }}
                            className="mt-4 border bg-white text-[#475569] px-4 py-2 rounded"
                        >
                                Cancel
                            </button>
                        </>
                    ): (
                        <>
                        <button
                            onClick={() => setIsEditing(true)}
                            type="button"
                            className="mt-4 bg-blue-500 text-white px-4 py-2 rounded"
                        >
                            Edit
                        </button>
                        <button
                            onClick={() => setSelectedContactModal(false)}
                            type="button"
                            style={{ backgroundColor: "#F9FAFB" }}
                            className="mt-4 border bg-white text-[#475569] px-4 py-2 rounded"
                        >
                                Dismiss
                            </button>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ContactsShowDetail;